import { axios } from '..';

const { REACT_APP_API_GATEWAY } = process.env;

export interface CitiesAndZipCodesSuggestion {
  zipCode: string;
  city: string;
}

export async function localitiesWithZipCodes(query: string): Promise<CitiesAndZipCodesSuggestion[]> {
  const url = `${REACT_APP_API_GATEWAY}/address/localitiesAndZipCodes`;

  const response = await axios.get(url, {
    params: {
      query,
      countryCode: 'FR',
    },
  });

  return response.data;
}

export async function zipCodesForLocality(query: string): Promise<CitiesAndZipCodesSuggestion[]> {
  const url = `${REACT_APP_API_GATEWAY}/address/zipCodesForLocality`;

  const response = await axios.get(url, {
    params: {
      query,
      countryCode: 'FR',
    },
  });

  return response.data;
}
